import React from "react";

/**
 * @description create gum function. In order to batch creation gum
 * @param props The parameter passed by the attribute within the tag
 * */
const Attachment = React.memo(function Attachment(props) {
  const { model, visible, opacity, color } = props;

  return (
    <mesh geometry={model} renderOrder={4} visible={visible} opacity={opacity}>
      <meshStandardMaterial
        color={color || "#BBABFF"}
        opacity={opacity}
        transparent={true}
        depthWrite={opacity > 0.5 ? true : false}
        depthTest={true}
        roughness={0.4}
        metalness={0}
        reflectivity={0.1}
        flatShading={true}
      />
    </mesh>
  );
});

export default Attachment;
